import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyDidntWork } from './components/WhyDidntWork';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream text-teal selection:bg-gold/30 selection:text-teal font-sans" data-id="element-0">
      {/* Noscript fallback for Meta Pixel */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1514363203367475&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <OpeningHook data-id="element-4" />
      <Problem data-id="element-5" />
      <WhyDidntWork data-id="element-6" />
      <Mechanism data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <ForWhom data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <Proof data-id="element-11" />
      <FAQ data-id="element-12" />
      <Offer data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}